import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Paper from "../../../../../mui/core/Paper";
import Grid from "../../../../../mui/core/Grid";
import SectionHeader from "../../../../../layout/SectionHeader";
import { LabeledText } from "../../../../../inputs/LabeledText";
import propTypes from "../../../../../../constants/propTypes";
import { getRfqInfo } from "./getRfqInfo";

const ContentWrapper = styled.div`
  padding: 20px 24px;
`;

function RfqInfoCard({ bidGroupVendor, timezone }) {
  if (!bidGroupVendor?.bidGroup) {
    return null;
  }

  const {
    rfqNumber,
    issueDate,
    formDueDate,
    requiredShipDate,
    specifier,
    vendorInstructions,
  } = getRfqInfo(bidGroupVendor, timezone);

  return (
    <Paper>
      <SectionHeader headerText="RFQ Details" />
      <ContentWrapper>
        <Grid container>
          <Grid item xs={12} sm={6} md={3}>
            <LabeledText label="RFQ #" texts={[rfqNumber]} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <LabeledText label="Issue Date" texts={[issueDate]} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <LabeledText label="Completed RFQ Form Due" texts={[formDueDate]} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <LabeledText
              label="Required Ship Date"
              texts={[requiredShipDate]}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <LabeledText label="Specifier" texts={[specifier]} />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <LabeledText
              label="Vendor Instructions"
              texts={[vendorInstructions]}
            />
          </Grid>
        </Grid>
      </ContentWrapper>
    </Paper>
  );
}

RfqInfoCard.propTypes = {
  bidGroupVendor: propTypes.bidGroupVendor,
  timezone: PropTypes.string,
};

export default RfqInfoCard;
